<template>
  <div>
    <button
      class="tw:flex tw:align-left tw:justify-between tw:items-center tw:w-full"
      @click="event => openTab(event, item.id)"
    >
      <div class="tw:flex tw:items-start tw:md:items-center tw:gap-4 tw:pr-2 tw:md:pr-1">
        <div class="tw:min-w-12 tw:mt-1 tw:md:mt-0">
          <img :src="item.icon" :alt="$t(item.title)" />
        </div>
        <div class="tw:w-auto tw:text-left">
          <p class="tw:font-bold tw:text-xl tw:mb-1" :class="{ 'tw:text-gray-500': item.isDisabled }">
            {{ $t(item.title) }}
          </p>
          <p class="tw:text-sm tw:text-gray-700">{{ $t(item.subtitle) }}</p>
          <button
            @click="showOffers"
            id="show-offers-btn"
            class="tw:hover:underline tw:text-sm tw:font-bold tw:text-blue-700 tw:hover:cursor-pointer"
            v-if="item.id === 3"
          >
            {{ $t('plus_product_page_offers') }}
          </button>
        </div>
      </div>

      <ChevronRight v-if="!item.isDisabled" class="tw:size-6" :class="arrowCustomClasses(item)" />
    </button>

    <Transition name="slide-fade">
      <div
        v-show="activeTab === 0 && item.id === activeTab"
        id="content-0"
        class="tw:px-4 tw:transition-all tw:duration-300 tw:ease-in-out"
      >
        <ul class="tw:list-disc tw:mt-8 tw:text-sm">
          <li v-for="(item, index) in item.list" :key="index" class="tw:mb-2" v-html="$t(item)" />
        </ul>
      </div>
    </Transition>
    <Transition name="slide-fade">
      <div
        v-show="activeTab === 1 && item.id === activeTab"
        id="content-1"
        class="tw:px-4 tw:transition-all tw:duration-300 tw:ease-in-out"
      >
        <ul class="tw:list-disc tw:mt-8 tw:text-sm">
          <li v-for="(item, index) in item.list" :key="index" class="tw:mb-2" v-html="$t(item)" />
        </ul>
      </div>
    </Transition>
    <Transition name="slide-fade">
      <div
        v-show="activeTab === 2 && item.id === activeTab"
        id="content-2"
        class="tw:px-4 tw:transition-all tw:duration-300 tw:ease-in-out"
      >
        <ul class="tw:list-disc tw:mt-8 tw:text-sm">
          <li v-for="(item, index) in item.list" :key="index" class="tw:mb-2" v-html="$t(item)" />
        </ul>
      </div>
    </Transition>
    <Transition name="slide-fade">
      <div
        v-show="activeTab === 3 && item.id === activeTab"
        id="content-3"
        class="tw:px-4 tw:transition-all tw:duration-300 tw:ease-in-out"
      >
        <ul class="tw:list-disc tw:mt-8 tw:text-sm">
          <li v-for="(item, index) in item.list" :key="index" class="tw:mb-2" v-html="$t(item)" />
        </ul></div
    ></Transition>
  </div>
</template>
<script setup>
import ChevronRight from '@/components/icons/ChevronRight.svg?component'

const props = defineProps({
  item: Object,
  activeTab: Number,
})

const emit = defineEmits(['openTab', 'showOffers'])
const openTab = (e, id) => emit('openTab', e, id)
const showOffers = () => emit('showOffers')

const arrowCustomClasses = () => {
  const classes = []
  if (props.item.isDisabled) {
    classes.push('tw:fill-gray-500')
  }
  if (props.item.id === props.activeTab) {
    classes.push('tw:-rotate-90')
  } else {
    classes.push('tw:rotate-90')
  }
  return classes.join(' ')
}
</script>
<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter-from {
  transform: translateY(-10px);
  opacity: 0;
  max-height: 0;
}

.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
  max-height: 0;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  max-height: 300px;
}
</style>
